

import { useAuthStore, useGlobalValueStore } from "../../stores";
import { useListCarritoXUser } from "../cache";





export const usePrecioCarritoXRole = () => {

    const { iva, view } = useGlobalValueStore();


    const obtenerPreciosCarritoIva = (data) => {
        if( !data ) return '$0';

        const totales = {
            cliente: data.reduce((acc, p) => acc + p.totalCliente, 0),
            distri: data.reduce((acc, p) => acc + p.totalDistri, 0),
            publicista: data.reduce((acc, p) => acc + p.totalPublicista, 0),
            empresa: data.reduce((acc, p) => acc + p.totalEmpresa, 0),
        };

        const totalView = totales[view] ?? 0;
        const valorIVA = iva ? Math.ceil(totalView * 0.19) : 0;
        const totalViewConIVA = totalView + valorIVA;

        return { ...totales, valorIVA, totalView, totalConIVA: totalViewConIVA };
    };



    const precioTotalSegunRol = (data) => {
        if( !data ) return '$0';
        
        const cliente = data.reduce( (total, prod) => total + prod.totalCliente, 0);
        const distri = data.reduce( (total, prod) => total + prod.totalDistri, 0);
        const empresa = data.reduce( (total, prod) => total + prod.totalEmpresa, 0);
        const publicista = data.reduce( (total, prod) => total + prod.totalPublicista, 0);

        switch(view){
            case "cliente":
                return cliente;

            case "distri": 
                return distri;

            case "disenio": 
                return publicista;

            case "empresa":
                return empresa;

            default:
                return cliente;
        }
    }



    const precioUnidadSegunRol = (carrito) => {
        switch(view){
            case "cliente":
                return carrito.totalCliente

            case "distri": 
                return carrito.totalDistri

            case "disenio": 
                return carrito.totalPublicista

            case "empresa":
                return carrito.totalEmpresa

            default:
                return carrito.totalCliente;
        }
    }


    return {
        obtenerPreciosCarritoIva,
        precioTotalSegunRol,
        precioUnidadSegunRol,
    }


}




